import DashboardWalletPortfolio from './DashboardWalletPortfolio';
export default DashboardWalletPortfolio;
